module.exports = __webpack_public_path__ + "static/media/logo_mcs_lite_black.abd19933.svg";


//////////////////
// WEBPACK FOOTER
// ./src/statics/images/logo_mcs_lite_black.svg
// module id = 554
// module chunks = 4